import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

export const api = {
  listUsers: (role) => http.get(`/users`, { params: role ? { role } : {} }).then(r => r.data),
  getUser: (id) => http.get(`/users/${id}`).then(r => r.data),
  listStudents: (params = {}) => http.get(`/students`, { params }).then(r => r.data),
  getStudent: (id) => http.get(`/students/${id}`).then(r => r.data),
  updateProfile: (id, patch) => http.put(`/students/${id}/profile`, patch).then(r => r.data),
  listExercises: (level) => http.get(`/exercises`, { params: level ? { level } : {} }).then(r => r.data),
  getExercise: (id) => http.get(`/exercises/${id}`).then(r => r.data),
  postProgress: (body) => http.post(`/progress`, body).then(r => r.data),
  listProgress: (student_id) => http.get(`/progress`, { params: { student_id } }).then(r => r.data),
  progressSummary: (student_id) => http.get(`/progress/summary/${student_id}`).then(r => r.data),
  listBadges: (student_id) => http.get(`/badges`, { params: { student_id } }).then(r => r.data),
  createAssignment: (body) => http.post(`/assignments`, body).then(r => r.data),
  listAssignments: (params) => http.get(`/assignments`, { params }).then(r => r.data),
  deleteAssignment: (id) => http.delete(`/assignments/${id}`).then(r => r.data),
  aiSummary: (body) => http.post(`/ai/summary`, body).then(r => r.data),
  report: (student_id) => http.get(`/report/${student_id}`).then(r => r.data),
};
